const loadGoogleMapsApi = require('load-google-maps-api');

(function() {

    const obj = document.getElementsByClassName('c-contact')[0];

    window.initMap = function() {
        let el = false;
        if (obj) {
            el = document.getElementsByClassName('js-map')[0];
        } else {
            el = document.getElementById('glightbox-slider').querySelector('.js-map');
        }

        let mapenable = false, int;

        const key = el.dataset.key;

        loadGoogleMapsApi({
            key: key
            }).then(function (googleMaps) {

            const lat = Number(el.getAttribute('data-lat')),
                  lng = Number(el.getAttribute('data-lng')),
                  myLatLng = new google.maps.LatLng(lat, lng);
                  markerHeight = 34,
                  markerWidth = 30;

            const map = new googleMaps.Map(el, {
                center: myLatLng,
                disableDefaultUI: false,
                zoom: 13,
                styles:[{"featureType":"all","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"color":"#444444"}]},{"featureType":"administrative.country","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":"-100"},{"lightness":"30"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"},{"gamma":"0.00"},{"lightness":"74"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"simplified"},{"color":"#ff0000"},{"saturation":"-15"},{"lightness":"40"},{"gamma":"1.25"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#ff0000"},{"lightness":"80"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#efefef"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]}]
            })

            const image = {
				url: el.getAttribute('data-marker'),
				size: new google.maps.Size(markerWidth, markerHeight),
				scaledSize: new google.maps.Size(markerWidth, markerHeight),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(markerWidth/2, markerHeight),
				labelOrigin: new google.maps.Point(0, markerHeight)
			}

			const marker = new google.maps.Marker({
				position: myLatLng,
				map: map,
				draggable: false,
				zIndex: 20,
				icon: image,
				animation: google.maps.Animation.DROP,
			});


        }).catch(function (error) {
            console.error(error)
        })


    };

   obj ? initMap() : false;

})();


